export default function cartMini({main, on, elm, state, publish}) {
	const dialog = elm.querySelector('dialog');

	main(_ => {
		elm.update = update;
		elm.display = display;

		on('click', '.minicart__close-btn', close);
		on('click', '.minicart', backdropClickHandle);
	});

	const update = async function () {
		const {language} = state.get();
		const action = `index.php?route=common/cart.info&language=${language}`;

		const loader = document.createElement('div');
		loader.classList.add('lmask');
		dialog.insertAdjacentElement('afterbegin', loader);

		try {
			const response = await fetch(action, {
				method: 'GET',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) {
				throw new Error(`Cart load failed: ${response.status}`);
			}

			const result = await response.json();
			dialog.innerHTML = result.cart;
			publish('cart-counter', result.counter);
		} catch (e) {
			alert(`Error fetching cart info: ${e}`);
		} finally {
			loader?.remove();
		}
	};

	const display = function () {
		dialog.showModal();
	};

	const close = () => {
		dialog.close();
	};

	const backdropClickHandle = function(e) {
		const dialogDimensions = dialog.getBoundingClientRect();
		if (
			e.clientX < dialogDimensions.left ||
			e.clientX > dialogDimensions.right ||
			e.clientY < dialogDimensions.top ||
			e.clientY > dialogDimensions.bottom
		) {
			dialog.close()
		}
	};
};

export const model = {};
